import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";

import Api from "../../../utils/api.utils";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import {
  resetState,
  setConsulltData,
} from "../../reducers/Consult/consultForm.reducer";
export const consultEntrySchema = Joi.object({
  name: Joi.string().trim().required().messages({
    "string.empty": "Speciality is required.",
  }),
});

export function useConsultForm({ existingStatus, existingImageUrl }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(existingStatus === 2 ? 0 : 1);
  const [Image, setImage] = useState(existingImageUrl);
  const [Id, setId] = useState("");
  const [Name, setName] = useState("");
  const handleFileChange = useCallback((img) => {
    setImage(img);
  }, []);
  const handleDeleteId = useCallback(
    (row) => {
      setImage(row.image_url);
      setId(row.id);
      setName(row.consult_name);
    },
    [Id, Name, Image]
  );
  const consultEntry = useCallback(
    async ({ name }) => {
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      const image_url = [];

      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        if (size(Image?.name) > 0) {
          const form = new FormData();
          form.append("file", Image);

          const image_response = await Api.post2(
            {
              url: Urls.imageAdd(),
              data: form,
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            },
            []
          );

          image_url.push(image_response?.data[0]);
        }

        const { data } = await apiPost({
          url: Urls.consultAdd(),
          data: {
            consult_name: name,
            image_url: image_url[0]?.url,
            status: status_Val,
            insert_by: null,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("Consult Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, Image]
  );

  const consultUpdate = useCallback(
    async ({ id, name }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      const image_url = [];

      try {
        dispatch(showPageLoader());

        if (size(Image?.name) > 0) {
          const form = new FormData();
          form.append("file", Image);

          const image_response = await Api.post2(
            {
              url: Urls.imageAdd(),
              data: form,
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            },
            []
          );

          image_url.push(image_response?.data[0]);
        }

        const { data } = await apiPost({
          url: Urls.consultUpdate(),
          data: {
            id: id,
            consult_name: name,
            image_url:
              size(image_url[0]?.url) > 0 ? image_url[0]?.url : Image?.url,
            status: status_Val,
            update_by: null,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("Consult Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, Image]
  );

  const consultDelete = useCallback(async () => {
    //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
    try {
      dispatch(showPageLoader());
      const { data } = await apiPost({
        url: Urls.consultUpdate(),
        data: {
          id: Id,
          consult_name: Name,
          image_url: Image,
          status: 2,
          update_by: "",
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data?.id) === 36) {
        enqueueSnackbar("Speciallity Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, [status, Id, Name, Image]);

  const getConsultbyId = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.getConsultDatabyId(),
          data: {
            id: id,
          },
        });

        dispatch(setConsulltData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    consultEntrySchema,
    handleStatusComboChange,
    consultEntry,
    consultUpdate,
    handleFileChange,
    getConsultbyId,
    consultDelete,
    handleDeleteId,
  };
}
